/* eslint-disable no-unused-vars */ /* eslint-disable no-unused-vars */
<template>
  <div class="card">
    <el-form
      label-width="100px"
      ref="ruleForm"
      :rules="rules"
      :model="ruleForm"
    >
      <el-form-item label="考核任务" prop="taskName">
        <el-input
          size="small"
          placeholder="请输入考核任务名称"
          v-model="ruleForm.taskName"
          maxlength="10"
        ></el-input>
      </el-form-item>
      <el-form-item label="周期类型" prop="timeType">
        <div>
          <el-radio-group v-model="ruleForm.timeType" @change="drawDateChange">
            <el-radio label="year">按年</el-radio>
            <el-radio label="month">按月</el-radio>
            <el-radio label="date">按日</el-radio>
          </el-radio-group>
          <div class="">
            <el-date-picker
              @change="changeDate"
              v-if="ruleForm.timeType === 'year'"
              size="small"
              v-model="ruleForm.planStartDate"
              ref="datepicker"
              value-format="yyyy"
              type="year"
              placeholder="开始年份"
              :picker-options="pickerStartOptions"
            >
            </el-date-picker>
            <span v-if="ruleForm.timeType === 'year'">至</span>
            <el-date-picker
              @change="changeDate"
              :disabled="ruleForm.planStartDate === ''"
              :picker-options="pickerOptions"
              v-if="ruleForm.timeType === 'year'"
              size="small"
              v-model="ruleForm.planEndDate"
              ref="datepicker"
              value-format="yyyy"
              type="year"
              placeholder="截止年份"
            >
            </el-date-picker>
            <el-date-picker
              @change="changeDate"
              v-if="ruleForm.timeType === 'month'"
              size="small"
              v-model="ruleForm.timeDate"
              ref="datepicker"
              value-format="yyyy-MM-dd"
              type="monthrange"
              range-separator="至"
              start-placeholder="开始月份"
              end-placeholder="结束月份"
            >
            </el-date-picker>
            <el-date-picker
              @change="changeDate"
              v-if="ruleForm.timeType === 'date'"
              size="small"
              v-model="ruleForm.timeDate"
              ref="datepicker"
              value-format="yyyy-MM-dd"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="评分计算方式">
        <el-radio-group v-model="ruleForm.calcMode" size="small">
          <el-radio label="calc_add">加和计算</el-radio>
          <el-radio label="calc_weight">加权计算</el-radio>
        </el-radio-group>
        <div class="form-tip">
          分数计算公式:加和:总分=评分直接累加，加权:总分=评分×指标权重，再累加
        </div>
      </el-form-item>
      <div class="caption flex item-center flex-end">考核指标</div>
      <el-form-item label="目标达成" prop="targetCompelete">
        <el-switch
          v-model="ruleForm.targetEnabledState"
          active-value="yes"
          inactive-value="no"
          @change="switchTargetEnabledState"
          active-color="#13ce66"
          inactive-color="#ff4949"
        >
        </el-switch>
        <div v-if="ruleForm.targetEnabledState === 'yes'">
          <div>
            <el-select
              placeholder="请选择要关联的目标达成类型的指标"
              style="margin-right: 20px"
              width="260px"
              size="small"
              v-model="ruleForm.targetCompleteField"
              clearable
            >
              <el-option
                :label="v.columnName"
                :value="v.columnId"
                v-for="(v, i) in targetFieldList"
                :key="i"
              >
              </el-option>
            </el-select>
            <el-button
              @click="addField('merits_target')"
              type="primary"
              plain
              size="small"
              >添加考核指标</el-button
            >
          </div>
          <div class="flex">
            <el-input
              size="small"
              type="number"
              @mousewheel.native.prevent
              style="width: 96px"
              class="mr20"
              @input="changeFullPoint"
              v-model="targetFullScore"
              placeholder="请填写满分值"
            ></el-input>
            <div v-if="ruleForm.calcMode === 'calc_weight'">
              <el-input
                size="small"
                v-model="targetWeight"
                @input="changeFullPoint"
                style="width: 96px"
                type="number"
                @mousewheel.native.prevent
                placeholder="请填写权重值"
              ></el-input>
              %
            </div>
          </div>
          <el-select
            placeholder="请选择目标任务"
            style="margin-right: 20px"
            size="small"
            v-model="ruleForm.templateId"
            clearable
          >
            <el-option
              :label="v.planTargetName"
              :value="v.targetId"
              v-for="(v, i) in targetTaskList"
              :key="i"
            >
            </el-option>
          </el-select>
        </div>
      </el-form-item>
      <el-form-item label="销售额" prop="saleAmount">
        <el-switch
          v-model="ruleForm.salesEnabledState"
          active-value="yes"
          @change="switchSalesEnabledState"
          inactive-value="no"
          active-color="#13ce66"
          inactive-color="#ff4949"
        >
        </el-switch>
        <div v-if="ruleForm.salesEnabledState === 'yes'">
          <div>
            <el-select
              placeholder="请选择要关联的销售额类型的指标"
              style="margin-right: 20px"
              size="small"
              width="260px"
              v-model="ruleForm.saleAmountField"
              clearable
            >
              <el-option
                :label="v.columnName"
                :value="v.columnId"
                v-for="(v, i) in saleAmountFieldList"
                :key="i"
              >
              </el-option>
            </el-select>
            <el-button
              @click="addField('merits_sales')"
              type="primary"
              plain
              size="small"
              >添加考核指标</el-button
            >
          </div>
          <div class="flex">
            <el-input
              size="small"
              type="number"
              @mousewheel.native.prevent
              style="width: 96px"
              @input="changeFullPoint"
              class="mr20"
              placeholder="请填写满分值"
              v-model="saleAmountFullScore"
            ></el-input>
            <div v-if="ruleForm.calcMode === 'calc_weight'">
              <el-input
                size="small"
                style="width: 96px"
                type="number"
                @mousewheel.native.prevent
                @input="changeFullPoint"
                v-model="saleAmountWeight"
                placeholder="请填写权重值"
              ></el-input>
              %
            </div>
          </div>
          <div class="mb20">
            <el-button
              type="primary"
              @click="addDrawer('category', '添加品类')"
              size="small"
              >添加品类</el-button
            >
            <el-button
              type="primary"
              @click="addDrawer('attribute', '添加属性')"
              size="small"
              >添加属性</el-button
            >
            <el-button
              type="primary"
              @click="addCate('brand', '添加品牌')"
              size="small"
              >添加品牌</el-button
            >
            <el-button
              type="primary"
              @click="addCate('goods', '添加商品')"
              size="small"
              >添加商品</el-button
            >
          </div>

          <el-table
            stripe
            border
            :data="cateResult"
            style="width: 100%"
            id="table"
            size="small"
            height="500"
          >
            <el-table-column type="selection"></el-table-column>
            <el-table-column type="index" label="序号"></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="attrType"
              label="添加状态"
            >
              <template slot-scope="scope">
                <div v-if="scope.row.attrType === 'category'">
                  添加品类
                </div>
                <div v-if="scope.row.attrType === 'attribute'">
                  添加属性
                </div>
                <div v-if="scope.row.attrType === 'brand'">
                  添加品牌
                </div>
                <div v-if="scope.row.attrType === 'goods'">
                  添加商品
                </div>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="attrType"
              label="编号（只显示商品货号）"
            >
              <template slot-scope="scope">
                <div v-if="scope.row.attrType === 'goods'">
                  {{ scope.row.attrId }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="attrValue"
              label="名称"
            ></el-table-column>
            <el-table-column label="操作" header-align="center" align="center">
              <template slot-scope="scope">
                <el-tooltip class="item" content="删除" placement="top">
                  <div
                    class="pointer mr10"
                    @click="removeCategory(scope.$index)"
                  >
                    <span class="hmicon icon-shanchu primary"></span>
                  </div>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form-item>
      <el-form-item label="自定义类型" prop="custom">
        <el-switch
          v-model="ruleForm.customEnabledState"
          active-value="yes"
          @change="switchCustomEnabledState"
          inactive-value="no"
          active-color="#13ce66"
          inactive-color="#ff4949"
        >
        </el-switch>
        <div v-if="ruleForm.customEnabledState === 'yes'">
          <div>
            <el-select
              placeholder="请选择要关联的自定义类型的指标"
              style="margin-right: 20px"
              size="small"
              width="260px"
              @change="relationCustomField"
              v-model="ruleForm.field"
              clearable
            >
              <el-option
                :label="v.columnName"
                :value="v.columnId"
                v-for="(v, i) in customFieldList"
                :key="i"
              >
              </el-option>
            </el-select>
            <el-button
              @click="addField('merits_custom')"
              type="primary"
              plain
              size="small"
              >添加考核指标</el-button
            >
          </div>
          <div
            class="flex item-center"
            v-for="(v, i) in selectedCustomField"
            :key="i"
          >
            <div class="mr10">{{ v.columnName }}</div>
            <div class="mr10">
              <el-input
                size="small"
                placeholder="请填写满分值"
                style="width: 96px"
                @input="changeFullPoint"
                v-model="v.fullPointValue"
              ></el-input>
            </div>
            <div class="mr10" v-if="ruleForm.calcMode === 'calc_weight'">
              <el-input
                size="small"
                style="width: 96px"
                v-model="v.weightPointValue"
                @input="changeFullPoint"
                type="number"
                @mousewheel.native.prevent
                placeholder="填写权重值"
              ></el-input>
              %
            </div>
            <div class="pinter" @click="removeCustomField(i)">
              <span class="hmicon icon-shanchu"></span>
            </div>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="满分" prop="fullPointValue">
        <el-input
          size="small"
          disabled
          v-model="ruleForm.fullPointValue"
          placeholder="请根据上面填写的值算出"
        ></el-input>
      </el-form-item>
      <el-form-item label="考核组" prop="examineGroup">
        <el-select
          placeholder="请选择考核组"
          multiple
          style="margin-right: 20px"
          size="small"
          v-model="ruleForm.examineGroup"
          clearable
        >
          <el-option
            :label="v.groupName"
            :value="v.groupId"
            v-for="(v, i) in groupList"
            :key="i"
          >
          </el-option>
        </el-select>
        <el-button @click="addGroup" type="primary" plain size="small"
          >添加考核组</el-button
        >
      </el-form-item>
      <div class="form-warning">
        <span></span>
      </div>
      <div class="flex flex-center">
        <el-button type="primary" @click="saveTask" size="small"
          >保存</el-button
        >
        <el-button size="small" @click="backExamineTask">返回</el-button>
      </div>
    </el-form>

    <el-dialog
      :title="title"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="1200px"
    >
      <div v-if="type === 'brand'">
        <div class="table-panel flex flex-end">
          <el-input
            clearable
            v-model.trim="searchCondition.keyWords"
            placeholder="搜索品牌"
            size="small"
            class="ipt mr10"
          ></el-input>
          <el-button type="primary" size="small" @click="searchAdd"
            >查询</el-button
          >
        </div>

        <el-table
          @sort-change="sortChange"
          stripe
          border
          ref="table"
          :data="addList"
          style="width: 100%"
          id="table"
          size="small"
          @selection-change="getChecked"
          :default-sort="{ prop: 'num', order: 'descending' }"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column
            type="index"
            label="序号"
            header-align="center"
            align="center"
            :index="index => index + (currentPageAdd - 1) * pageSizeAdd + 1"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="brandName"
            label="品牌名称"
          >
            <template slot-scope="scope">
              {{ scope.row.brandName }}
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            show-overflow-tooltip
            align="center"
            prop="brandLogo"
            label="品牌logo图"
          >
            <template slot-scope="scope">
              <img
                :src="scope.row.brandLogo"
                alt
                style="width:60px;height:60px"
                v-if="scope.row.brandLogo"
              />
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="brandAcronym"
            label="品牌首字母"
            sortable
          >
            <template slot-scope="scope">
              {{ scope.row.brandAcronym }}
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="relationSpu"
            label="相关商品"
            sortable
          >
            <template slot-scope="scope">
              {{ scope.row.relationSpu }}
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div v-if="type === 'goods'">
        <div class="table-panel flex flex-end">
          <el-input
            clearable
            style="width: 300px"
            v-model.trim="searchCondition.keyWords"
            size="small"
            :placeholder="placeholder"
            class="ipt mr10"
          >
            <el-select
              slot="prepend"
              size="small"
              style="width:100px"
              @change="selectQueryType"
              v-model="searchCondition.queryType"
              clearable
            >
              <el-option label="商品名" value="spu_name"></el-option>
              <el-option label="货号" value="goods_sn"></el-option>
              <el-option label="条码" value="spec_barcode"></el-option>
            </el-select>
          </el-input>
          <el-button type="primary" size="small" @click="searchAdd"
            >查询</el-button
          >
        </div>
        <el-table
          stripe
          border
          ref="table"
          :data="addList"
          style="width: 100%"
          id="table"
          size="small"
          @selection-change="getChecked"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column
            type="index"
            label="序号"
            header-align="center"
            align="center"
            :index="index => index + (currentPageAdd - 1) * pageSizeAdd + 1"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="wxshopSpuName"
            label="商品名称"
          >
            <template slot-scope="scope">
              {{ scope.row.wxshopSpuName }}
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="brandName"
            label="商品品牌"
          >
            <template slot-scope="scope">
              {{ scope.row.brandName }}
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="goodsSn"
            label="商品货号"
          >
            <template slot-scope="scope">
              {{ scope.row.goodsSn }}
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="spuBarcode"
            label="商品条码"
          >
            <template slot-scope="scope">
              {{ scope.row.spuBarcode }}
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="hm-pagination">
        <el-pagination
          background
          :total="totalAdd"
          @current-change="pagingAdd"
          @size-change="handleSizeChangeAdd"
          :page-sizes="[10, 50, 100, 200]"
          layout="total, sizes,  prev, pager, next, jumper"
          :current-page="1"
        ></el-pagination>
      </div>

      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button @click="saveSelected" size="small" type="primary"
          >保存</el-button
        >
        <el-button @click="dialogVisible = false" size="small">取消</el-button>
      </span>
    </el-dialog>

    <el-drawer
      custom-class="hm-drawer"
      :title="title"
      :wrapperClosable="false"
      :visible.sync="drawer"
      :before-close="handleClose"
    >
      <div class="drawer-content" v-if="type === 'category'">
        <div class="title mb20">所有的品类：</div>
        <el-input
          placeholder="输入关键字搜索"
          clearable
          v-model="filterText"
          size="small"
        >
        </el-input>
        <el-tree
          v-if="type === 'category'"
          :filter-node-method="filterNode"
          empty-text="暂无品类"
          :props="props"
          node-key="attrId"
          ref="category"
          :load="loadNode"
          lazy
          highlight-current
          show-checkbox
        ></el-tree>
      </div>
      <div class="drawer-content" v-if="type === 'attribute'">
        <div class="title">所有的属性：</div>
        <el-input
          placeholder="输入关键字进行搜索"
          clearable
          v-model="filterText"
          size="small"
        >
        </el-input>
        <el-tree
          v-if="type === 'attribute'"
          :filter-node-method="filterNode"
          empty-text="暂无属性"
          :props="props"
          node-key="attrId"
          ref="attribute"
          :load="loadNode"
          lazy
          highlight-current
          show-checkbox
        ></el-tree>
      </div>
      <div class="drawer-footer flex flex-center ">
        <el-button type="primary" size="small" @click="saveSelected"
          >保存</el-button
        >
        <el-button size="small" @click="handleClose">取 消</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { arrayUnique2 } from "@/utils/utils";
import { mapGetters } from "vuex";

export default {
  computed: mapGetters(["taskInfo"]),
  data() {
    const validateTimeType = (rule, val, callback) => {
      switch (this.ruleForm.timeType) {
        case "year":
          if (!this.ruleForm.planStartDate || !this.ruleForm.planEndDate) {
            return callback(new Error("请选择起始与结束时间"));
          }
          break;
        case "date":
        case "month":
          if (
            !this.ruleForm.timeDate ||
            (this.ruleForm.timeDate && !this.ruleForm.timeDate.length)
          ) {
            return callback(new Error("请选择起始与结束时间"));
          }
          break;
        default:
          break;
      }
      callback();
    };
    const validateTargetComplete = (rule, val, callback) => {
      if (this.ruleForm.targetEnabledState === "yes") {
        if (!this.ruleForm.targetCompleteField) {
          return callback(new Error("请选择关联的指标"));
        }
        if (!this.targetFullScore) {
          return callback(new Error("请填写满分值"));
        }
        if (!this.targetWeight && this.ruleForm.calcMode === "calc_weight") {
          return callback(new Error("请填写权重值"));
        }
        if (!this.ruleForm.templateId) {
          return callback(new Error("请选择目标任务"));
        }
      }
      callback();
    };

    const validateSaleAount = (rule, val, callback) => {
      if (this.ruleForm.salesEnabledState === "yes") {
        if (!this.ruleForm.saleAmountField) {
          return callback(new Error("请选择关联的指标"));
        }
        if (!this.saleAmountFullScore) {
          return callback(new Error("请填写满分值"));
        }
        if (
          !this.saleAmountWeight &&
          this.ruleForm.calcMode === "calc_weight"
        ) {
          return callback(new Error("请填写权重值"));
        }
        if (!this.cateResult.length) {
          return callback(new Error("请选择销售额类型"));
        }
      }
      callback();
    };
    const validateCustom = (rule, val, callback) => {
      if (!this.selectedCustomField.length) {
        return callback(new Error("请选择关联的指标"));
      } else {
        const haveEmptyFullScore =
          this.selectedCustomField.findIndex(v => !v.fullPointValue) !== -1;
        const haveEmptyFullWeight =
          this.selectedCustomField.findIndex(v => !v.weightPointValue) !== -1;
        if (haveEmptyFullScore) {
          return callback(new Error("请填写满分值"));
        }
        if (haveEmptyFullWeight && this.ruleForm.calcMode === "calc_weight") {
          return callback(new Error("请填写权重值"));
        }
      }
      callback();
    };
    return {
      selectedCustomField: [],
      targetTaskList: [],
      pageSizeAdd: 10,
      currentPageAdd: 1,
      addList: [],
      totalAdd: 0,
      title: "",
      type: "",
      dialogVisible: false,
      ruleForm: {
        taskName: "",
        planStartDate: "",
        planEndDate: "",
        timeDate: "",
        timeType: "year",
        calcMode: "calc_add",
        customEnabledState: "no",
        salesEnabledState: "no",
        targetEnabledState: "no",
        fullPointValue: "",
        fullWeight: "",
        targetTask: "",
        targetCompleteField: "",
        saleAmountField: "",
        templateId: ""
      },
      targetFieldList: [],
      saleAmountFieldList: [],
      customFieldList: [],
      rules: {
        saleAmount: {
          required: true,
          validator: validateSaleAount
        },
        custom: {
          required: true,
          validator: validateCustom
        },
        targetCompelete: {
          required: true,
          validator: validateTargetComplete
        },
        taskName: {
          required: true,
          message: "请输入考核任务名称",
          trigger: "blur"
        },
        timeType: {
          required: true,
          validator: validateTimeType
        },
        examineGroup: {
          required: true,
          message: "请选择考核分组",
          trigger: "change"
        }
      },
      searchCondition: {},
      category: "",
      selectedData: [],
      cateResult: [],
      selectedGoodsAndBrand: [],
      categoryList: [
        {
          key: "category",
          value: "品类"
        },
        {
          key: "brand",
          value: "品牌"
        },
        {
          key: "attribute",
          value: "属性"
        },
        {
          key: "goods",
          value: "商品"
        }
      ],
      placeholder: "",
      dialogTitle: "添加考核任务",
      levelName: "",
      drawer: false,
      levelList: [],
      filterText: "",
      levelTotal: 0,
      currentLevel: {},
      levelCurrentPage: 1,
      groupList: [],
      levelPageSize: 10,
      relationDialogVisible: false,
      searchConditons: {
        taskName: ""
      },
      props: {
        value: "attrId",
        label: "attrValue",
        children: "children",
        isLeaf: "leaf"
      },
      activeTab: "examineTasK",
      total: 0,
      currentPage: 1,
      list: [],
      currentRow: {},
      pageSize: 10,
      sort: {},
      targetFullScore: "",
      targetWeight: "",
      saleAmountFullScore: "",
      saleAmountWeight: "",
      statusList: [
        {
          name: "考核任务设置",
          value: "examineTasK"
        },
        {
          name: "考核组设置",
          value: "examineGroup"
        },
        {
          name: "指标字段设置",
          value: "indicatorField"
        },
        {
          name: "绩效等级设置",
          value: "performanceLevel"
        }
      ],
      operationType: "",
      operationId: "",
      pickerOptions: {
        //disabled为函数，返回值为布尔值，
        disabledDate: time => {
          let minYear = new Date(this.ruleForm.planStartDate).getFullYear();
          return time.getTime() < new Date(JSON.stringify(minYear));
        }
      },
      pickerStartOptions: {
        disabledDate: time => {
          let minYear = new Date().getFullYear();
          return time.getTime() < new Date(JSON.stringify(minYear));
        }
      }
    };
  },
  created() {
    this.operationType = this.$route.query.operationType;
    if (this.operationType === "edit") {
      this.operationId = this.$route.query.operationId;
      this.queryTargetTaskDetails();
    }
  },
  mounted() {
    if (this.taskInfo) {
      const { data } = this.taskInfo;
      this._data = data;
      this.$store.commit("SAVE_TASK_INFO", null);
    }
    this.queryAllFieldList();
    this.queryExamineGroupList();
  },

  methods: {
    async queryTargetTaskDetails() {
      const { result } = await this.$store.dispatch("queryTargetTaskDetails", {
        id: this.operationId
      });
      for (let key in result) {
        if (this.ruleForm.hasOwnProperty(key)) {
          this.ruleForm[key] = result[key];
        }
      }
      this.ruleForm.examineGroup = result.groupList.map(v => v.groupId);
      this.ruleForm.timeType = result.loopType;
      if (result.loopType === "date") {
        this.ruleForm.planStartDate = result.loopStartValue;
        this.ruleForm.planEndDate = result.loopEndValue;
      } else {
        this.ruleForm.timeDate = [result.loopStartValue, result.loopEndValue];
      }
      await this.queryTargetList();
      const { tempList, salesList, customList } = result;
      // 目标
      this.ruleForm.targetCompleteField = tempList[0].columnId;
      this.targetFullScore = tempList[0].fullPointValue;
      this.targetWeight = tempList[0].weightPointValue;
      this.ruleForm.templateId = tempList[0].templateId;
      // 销售额
      salesList.map(v => {
        this.ruleForm.saleAmountField = v.columnId;
        this.saleAmountFullScore = v.fullPointValue;
        this.saleAmountWeight = v.weightPointValue;
        this.cateResult.push({
          attrType: v.goodsType,
          attrId: v.goodsTypeId,
          attrValue: v.templateName
        });
        this.selectedData = this.cateResult;
      });
      // 自定义类型
      this.ruleForm.field = customList[0].columnId;
      this.selectedCustomField = customList;
    },
    async saveTask() {
      let haveOneQuota =
        this.ruleForm.targetEnabledState === "yes" ||
        this.ruleForm.salesEnabledState === "yes" ||
        this.ruleForm.customEnabledState === "yes";
      if (!haveOneQuota) {
        this.$message({
          type: "warning",
          message: "至少选择一个指标"
        });
        return;
      }
      if (this.ruleForm.calcMode === "calc_weight") {
        if (this.ruleForm.fullWeight !== 100) {
          this.$message({
            type: "warning",
            message: "权重累加应等于100"
          });
          return;
        }
      }
      const valid = await this.$refs.ruleForm.validate();
      if (valid) {
        let params = JSON.parse(JSON.stringify(this.ruleForm));
        // eslint-disable-next-line no-unused-vars
        let planStartDate = params.planStartDate;
        // eslint-disable-next-line no-unused-vars
        let planEndDate = params.planEndDate;
        if (params.timeDate && params.timeDate.length) {
          planStartDate = params.timeDate[0];
          planEndDate = params.timeDate[1];
        }
        params.loopType = params.timeType;
        params.loopStartValue = planStartDate;
        params.loopEndValue = planEndDate;
        params.taskGroupInfoModelList = params.examineGroup.map(groupId => {
          return {
            groupId
          };
        });

        let taskCloumsRelList = [];
        if (this.ruleForm.targetEnabledState === "yes") {
          taskCloumsRelList = [
            {
              columnId: this.ruleForm.targetCompleteField,
              templateId: this.ruleForm.templateId,
              templateType: "merits_target",
              fullPointValue: this.targetFullScore,
              weightPointValue: this.targetWeight
            }
          ];
        }
        let saleAmountTaskCloumsRelList = [];
        if (this.ruleForm.salesEnabledState === "yes") {
          this.cateResult.map(v => {
            saleAmountTaskCloumsRelList.push({
              columnId: this.ruleForm.saleAmountField,
              goodsTypeId: v.attrId,
              goodsType: v.attrType,
              templateId: null,
              templateType: "merits_sales",
              fullPointValue: this.saleAmountFullScore,
              weightPointValue: this.saleAmountWeight
            });
          });
        }
        let customTaskCloumsRelList = [];
        if (this.ruleForm.customEnabledState === "yes") {
          this.selectedCustomField.map(v => {
            customTaskCloumsRelList.push({
              columnId: v.columnId,
              templateId: null,
              templateType: "merits_custom",
              fullPointValue: v.fullPointValue,
              weightPointValue: v.weightPointValue
            });
          });
        }
        params.taskCloumsRelList = [
          ...taskCloumsRelList,
          ...saleAmountTaskCloumsRelList,
          ...customTaskCloumsRelList
        ];
        let url = "addExamineTask";
        if (this.operationType === "edit") {
          url = "editExamineTask";
          Object.assign(params, {
            id: this.operationId
          });
        }
        await this.$store.dispatch(url, params);
        this.$message({
          type: "success",
          message: "操作成功"
        });
        this.backExamineTask();
      }
    },
    changeFullPoint() {
      let fullPointValue = 0;
      let fullWeight = 0;
      if (this.ruleForm.calcMode === "calc_weight") {
        fullPointValue += this.targetFullScore * (this.targetWeight / 100);
        fullWeight += +this.targetWeight;
        fullPointValue +=
          this.saleAmountFullScore * (this.saleAmountWeight / 100);
        fullWeight += +this.saleAmountWeight;
        this.selectedCustomField.map(v => {
          fullPointValue += v.fullPointValue * (v.weightPointValue / 100);
          fullWeight += +v.weightPointValue;
        });
      } else {
        fullPointValue += +this.targetFullScore;
        fullPointValue += +this.saleAmountFullScore;
        this.selectedCustomField.map(v => {
          fullPointValue += +v.fullPointValue;
        });
      }
      fullPointValue = (+fullPointValue).toFixed(2);
      this.ruleForm.fullPointValue = +fullPointValue;
      this.ruleForm.fullWeight = +fullWeight;
    },
    backExamineTask() {
      this.$router.push({
        name: "ExamineTask"
      });
    },
    switchSalesEnabledState() {
      this.ruleForm.saleAmountField = "";
      this.saleAmountFullScore = "";
      this.saleAmountWeight = "";
      this.cateResult = [];
      this.changeFullPoint();
    },
    switchTargetEnabledState() {
      this.ruleForm.targetCompleteField = "";
      this.targetFullScore = "";
      this.targetWeight = "";
      this.ruleForm.templateId = "";
      this.changeFullPoint();
    },
    switchCustomEnabledState() {
      this.selectedCustomField = [];
      this.ruleForm.field = "";
      this.changeFullPoint();
    },
    removeCustomField(i) {
      this.selectedCustomField.splice(i, 1);
    },
    changeDate() {
      if (
        (this.ruleForm.planStartDate && this.ruleForm.planEndDate) ||
        (this.ruleForm.timeDate && this.ruleForm.timeDate.length)
      ) {
        this.queryTargetList();
      } else {
        this.targetTaskList = [];
        this.ruleForm.targetTask = "";
      }
    },
    async queryTargetList() {
      let planStartDate = this.ruleForm.planStartDate;
      let planEndDate = this.ruleForm.planEndDate;
      if (this.ruleForm.timeDate && this.ruleForm.timeDate.length) {
        planStartDate = this.ruleForm.timeDate[0];
        planEndDate = this.ruleForm.timeDate[1];
      }
      const { result } = await this.$store.dispatch("queryTargetList", {
        timeType: this.ruleForm.timeType,
        planStartDate,
        planEndDate
      });
      this.targetTaskList = result;
    },
    relationCustomField(columnId) {
      const row = this.customFieldList.find(v => v.columnId === columnId);
      const copyRow = JSON.parse(JSON.stringify(row));
      copyRow.fullPointValue = "";
      copyRow.weightPointValue = "";
      this.selectedCustomField.push(copyRow);
      this.selectedCustomField = arrayUnique2(
        this.selectedCustomField,
        "columnId"
      );
    },
    addCate(type, title) {
      if (type === "goods") {
        this.searchCondition = {
          queryType: "spu_name"
        };
      } else {
        this.searchCondition = {};
      }
      this.addList = [];
      this.totalAdd = 0;
      this.title = title;
      this.type = type;
      this.queryAddList();
      this.dialogVisible = true;
    },
    handleClose() {
      this.drawer = false;
      this.type = "";
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.attrValue.indexOf(value) !== -1;
    },
    addDrawer(type, title) {
      this.type = type;
      this.title = title;
      this.drawer = true;
      setTimeout(() => {
        this.$refs[this.type].setCheckedKeys([]);
      }, 0);
    },
    sortChange(sort) {
      this.sort = sort;
      this.queryAddList();
    },
    changeCategory() {
      this.type = this.category;
      switch (this.category) {
        case "goods":
          this.searchCondition = {
            queryType: "spu_name"
          };
          this.title = "添加商品";
          break;
        default:
          this.searchCondition = {};
          break;
      }
      this.addList = [];
      this.totalAdd = 0;
      this.queryAddList();
      this.dialogVisible = true;
    },
    saveSelected() {
      let data = [];
      if (this.selectedGoodsAndBrand.length) {
        data = this.selectedData.concat(this.selectedGoodsAndBrand);
        this.selectedGoodsAndBrand = [];
      }
      if (this.$refs[this.type]) {
        let checkCateAndAttrList = [];
        checkCateAndAttrList = this.getSimpleCheckedNodes(
          this.$refs[this.type].store
        );
        data = this.selectedData.concat(checkCateAndAttrList);
      }
      if (!data.length) {
        this.$message({
          type: "error",
          message: "请选择"
        });
        return;
      }
      const attrType = data[0].attrType;
      if (data.findIndex(v => attrType && v.attrType !== attrType) > -1) {
        this.$message({
          type: "error",
          message: "只能添加同一类型的数据"
        });
        return;
      }
      this.dialogVisible = false;
      this.drawer = false;
      this.selectedData = [...new Set(data)];
      this.selectedData = arrayUnique2(this.selectedData, "attrId");
      this.cateResult = this.selectedData;
      this.$refs.ruleForm.validate();
    },

    loadNode(node, resolve) {
      // 一级节点处理
      if (node.level === 0) {
        this.requestTree(resolve);
      }
      // 其余节点处理
      if (node.level >= 1) {
        // 注意！把resolve传到你自己的异步中去
        this.getIndex(node, resolve);
      }
    },
    requestTree(resolve) {
      if (this.type === "category") {
        this.$store
          .dispatch("queryGoodsCategoryTree", {
            categoryLevel: 1
          })
          .then(res => {
            const data = res.result;
            data.forEach(v => {
              v.attrId = v.categoryId;
              v.attrValue = v.categoryName;
              v.attrType = "category";
            });
            let categoryList = [];
            this.addList.map(v => {
              if (v.attrType === "category") {
                categoryList.push(v);
              }
            });
            let check = categoryList.map(o => o.attrId);
            this.$refs[this.type].setCheckedKeys(check);
            resolve(data);
          })
          .catch(err => {
            throw new Error(err);
          });
      } else {
        this.$store
          .dispatch("queryAttributeType")
          .then(res => {
            const data = res.result;
            data.forEach(v => {
              v.attrId = v.typeId;
              v.attrValue = v.typeName;
              v.attrType = "attribute";
              // v.disabled = true;
            });
            let attributeList = [];
            this.addList.map(v => {
              if (v.attrType === "attribute") {
                attributeList.push(v);
              }
            });
            let check = attributeList.map(o => o.attrId);
            this.$refs[this.type].setCheckedKeys(check);
            resolve(data);
          })
          .catch(err => {
            throw new Error(err);
          });
      }
    },
    // 异步加载叶子节点数据函数
    getIndex(node, resolve) {
      if (this.type === "category") {
        this.$store
          .dispatch("queryGoodsCategoryTree", {
            parentCategoryId: node.data.categoryId,
            categoryLevel: node.level + 1
          })
          .then(res => {
            const data = res.result;
            data.forEach(v => {
              v.attrId = v.categoryId;
              v.attrValue = v.categoryName;
              v.attrType = "category";
            });
            resolve(data);
          })
          .catch(err => {
            throw new Error(err);
          });
      } else {
        this.$store
          .dispatch("queryAttributeChildrenType", {
            typeId: node.data.attrId
          })
          .then(res => {
            const data = res.result;
            data.forEach(v => {
              v.attrId = v.attributeId;
              v.attrValue = v.userName;
              v.attrType = "attribute";
            });
            resolve(data);
          })
          .catch(err => {
            throw new Error(err);
          });
      }
    },
    async queryAddList() {
      let params = {
        pageNo: this.currentPageAdd,
        pageSize: this.pageSizeAdd
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      Object.assign(params, searchCondition);
      if (this.type === "brand") {
        params.order = this.sort.order;
        params.prop = this.sort.prop;
        const { result } = await this.$store.dispatch(
          "queryBrandActivityList",
          params
        );
        this.addList = result.records;
        this.addList.forEach(v => {
          v.attrValue = v.brandName;
          v.attrId = v.brandId;
          v.attrType = "brand";
        });
        this.totalAdd = result.total;
      } else if (this.type === "goods") {
        const { result } = await this.$store.dispatch(
          "queryMicroShopGoodsList",
          params
        );
        this.addList = result.records;
        this.addList.forEach(v => {
          v.attrValue = v.wxshopSpuName;
          v.attrId = v.goodsSn;
          v.attrType = "goods";
        });
        this.totalAdd = result.total;
      }
    },
    selectQueryType(queryType) {
      if (queryType === "spuName") {
        this.placeholder = "请输入商品名";
      } else if (queryType === "goodsSn") {
        this.placeholder = "请输入货号";
      } else if (queryType === "specBarcode") {
        this.placeholder = "请输入条码";
      } else if (queryType === "brandName") {
        this.placeholder = "请输入品牌名";
      }
    },
    getChecked(selection) {
      this.selectedGoodsAndBrand = selection;
    },
    searchAdd() {
      this.currentPageAdd = 1;
      this.queryAddList();
    },
    pagingAdd(page) {
      this.currentPageAdd = page;
      this.queryAddList();
    },
    handleSizeChangeAdd(size) {
      this.pageSizeAdd = size;
      this.currentPageAdd = 1;
      this.queryAddList();
    },
    removeCategory(i) {
      this.selectedData.splice(i, 1);
      this.cateResult = this.selectedData;
    },
    // 打开添加考核指标
    addField(itemValue) {
      this.$router.push({
        name: "ExamineTask",
        query: {
          activeTab: "indicatorField"
        }
      });
      this.$store.commit("SAVE_TASK_INFO", {
        data: this._data,
        page: "ExamineTask",
        itemValue
      });
      this.$emit("switchTab", "examineGroup");
    },
    // 打开添加考核组
    addGroup() {
      this.$router.push({
        name: "ExamineTask",
        query: {
          activeTab: "examineGroup"
        }
      });
      this.$store.commit("SAVE_TASK_INFO", {
        data: this._data,
        page: "ExamineGroup"
      });
    },
    resetRuleForm() {},
    drawDateChange() {
      this.ruleForm.planStartDate = "";
      this.ruleForm.planEndDate = "";
      this.ruleForm.timeDate = "";
    },
    async relationLevel(row) {
      this.currentRow = row;
      this.relationDialogVisible = true;
      this.queryLevel();
    },

    getSimpleCheckedNodes(store) {
      const checkedNodes = [];
      const traverse = function(node) {
        const childNodes = node.root ? node.root.childNodes : node.childNodes;

        childNodes.forEach(child => {
          if (child.checked) {
            checkedNodes.push({
              attrId: child.data.attrId,
              attrValue: child.data.attrValue,
              attrType: child.data.attrType
            });
          }
          if (child.indeterminate) {
            traverse(child);
          }
        });
      };
      traverse(store);

      return checkedNodes;
    },
    levelPaging(page) {
      this.levelCurrentPage = page;
      this.queryLevel();
    },
    levelHandleSizeChange(size) {
      this.levelCurrentPage = 1;
      this.pageSize = size;
      this.queryLevel();
    },
    handleCurrentChange(row) {
      this.currentLevel = row;
    },
    async queryLevel() {
      const { result } = await this.$store.dispatch(
        "queryAllMicroShopGoodsList",
        {
          pageSize: this.levelPageSize,
          pageNo: this.levelCurrentPage
        }
      );
      const { records, total } = result;
      this.levelList = records;
      this.levelTotal = total;
    },
    async saveRelation() {
      if (!this.currentLevel.id) {
        this.$message({
          type: "warning",
          message: "请先选择等级"
        });
        return;
      }
      this.relationDialogVisible = false;
    },

    async queryAllFieldList() {
      const targetFieldList = await this.$store.dispatch(
        "queryIndicatorFieldList",
        {
          autoTemplateType: "merits_target",
          pageSize: 99999,
          pageNo: 1
        }
      );
      const saleAmountFieldList = await this.$store.dispatch(
        "queryIndicatorFieldList",
        {
          autoTemplateType: "merits_sales",
          pageSize: 99999,
          pageNo: 1
        }
      );
      const customFieldList = await this.$store.dispatch(
        "queryIndicatorFieldList",
        {
          autoTemplateType: "merits_custom",
          pageSize: 99999,
          pageNo: 1
        }
      );
      targetFieldList.result.records.forEach(v => {
        v.columnId = v.id;
      });
      saleAmountFieldList.result.records.forEach(v => {
        v.columnId = v.id;
      });
      customFieldList.result.records.forEach(v => {
        v.columnId = v.id;
      });
      this.targetFieldList = targetFieldList.result.records;
      this.saleAmountFieldList = saleAmountFieldList.result.records;
      this.customFieldList = customFieldList.result.records;
    },
    async queryExamineGroupList() {
      const { result } = await this.$store.dispatch("queryExamineGroupList", {
        pageNo: 1,
        pageSize: 99999
      });
      const { records } = result;
      records.forEach(v => {
        v.groupId = v.id;
      });
      this.groupList = records;
    }
  }
};
</script>

<style scoped lang="scss">
.card {
  background: #fff;
  padding: 15px;
}
.table-panel {
  background: #fff;
  padding: 15px;
}

.table {
  .line {
    width: 1px;
    margin: 0 10px;
    height: 12px;
    background: #ddd;
  }
}

.relation-container {
  .label-row {
    margin-bottom: 20px;
    .label {
      font-size: 14px;
      font-weight: bold;
      margin-right: 20px;
    }
  }
  .panel {
    margin-bottom: 20px;
  }
}

.caption {
  font-size: 16px;
  margin: 28px 0;
  width: 86px;
  text-align: right;
  color: #222;
  &::before {
    content: "";
    width: 4px;
    height: 16px;
    border-radius: 2px 0px 2px 0px;
    background: #e50065;
    margin-right: 5px;
  }
}
</style>
